/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoReplacementUpdateMutation(
  $phoneNumberoReplacementId: ID,
  $phoneNumberoReplacementIds: [ID!],
  $type: CUSTOMER_TYPE,
  $mcc: String!,
  $mnc: [String!]!,
  $phoneNumberoDirectoryId: ID,
  $phoneNumbero: [ID],
  $percentageRate: Float
) {
  PhoneNumberoReplacementUpdate(
    phoneNumberoReplacementId: $phoneNumberoReplacementId,
    phoneNumberoReplacementIds: $phoneNumberoReplacementIds,
    type: $type,
    mcc: $mcc,
    mnc: $mnc,
    phoneNumberoDirectoryId: $phoneNumberoDirectoryId,
    phoneNumbero: $phoneNumbero,
    percentageRate: $percentageRate
  ) {
    id
    message
    status
  }
}
`
